<template>
    <div>
      <span v-if="isLoading">{{ authority }}&hellip;</span>
      <span v-if="!isLoading && page">
        <span v-if="error" class="text-danger">{{ error }}</span>

        <!-- no contacts added -->
        <div 
          class="authority" 
          v-b-tooltip.hover title="No contacts have been added for this council"
          v-if="page.Contacts.length === 0">{{ authority }}</div>

        <!-- contacts -->
        <a href="javascript:void(0);" class="authority" @click="show=true" v-if="page.Contacts.length > 0" v-b-modal.contactModal>{{ authority }}</a>
        <b-modal v-model="show" size="lg" :title="`Contacts for ${authority}`" :hide-footer="true">
          <contact-table :short="true" :contacts="page.Contacts"/>
        </b-modal>
      </span>
    </div>
</template>

<script>
import ContactTable from './ContactTable.vue'

export default {
  components: { ContactTable },
  props: ['authority'],
  data() {
    return {
      show: false,
      isLoading: true,
      error: null,
      page: null,
    };
  },
  mounted() {
    this.$store.dispatch('getCache', {
      name: `contacts_for_${this.authority}`,
      fallback: () => {
        this.isLoading = true;
        const { access_token } = this.$store.state.oidcStore;
        return this.$reportingApi.renderPage('panessex', access_token, {
          pageName: 'authorities_contacts',
          parameters: {
            authority: this.authority,
          }
        })
        .then((page) => {
          this.$store.commit('cache', { name: `contacts_for_${this.authority}`, item: page });
          return page;
        });
      },
    })
    .then(page => { this.page = page; this.isLoading = false; })
    .catch(e => { this.error = e.message; this.isLoading = false; });
  },
};
</script>
